import { IFilter } from '../../types/filters';
import { ConstructionTypeContainer } from '../../containers/advancedFilters/ConstructionTypeContainer';

export const constructionType: IFilter = {
  component: ConstructionTypeContainer,
};
